import { Field, Label, Radio, RadioGroup } from '@headlessui/react';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import React, { useCallback, useEffect } from 'react';

import { useFilterContext } from '../lib';
import { AnimalType as AnimalTypeType, animalTypes, animalTypesMap } from '../models';

interface Props {
  urlSearchParams: URLSearchParams;
}

const AnimalType: React.FC<Props> = ({ urlSearchParams }) => {
  const { setAnimalType, animalType } = useFilterContext();

  const param = urlSearchParams.get('animal-type');

  const updateUrl = useCallback(
    (value: AnimalTypeType[number]) => {
      urlSearchParams.set('animal-type', value);
    },
    [urlSearchParams]
  );

  const changeRadioSelectHandle = (value: AnimalTypeType[number]) => {
    setAnimalType(value);
    sessionStorage.setItem('animal-type', value);
    updateUrl(value);
  };

  useEffect(() => {
    if (param === 'all') {
      setAnimalType('all');
    }
  }, [param, setAnimalType]);

  useEffect(() => {
    const savedType = sessionStorage.getItem('animal-type') as AnimalTypeType[number] | undefined;
    if (!savedType) {
      sessionStorage.setItem('animal-type', animalType as string);
    } else {
      updateUrl(savedType);
    }

    setAnimalType(savedType ?? animalType);
  }, [animalType, setAnimalType, updateUrl]);

  return (
    <RadioGroup
      value={animalType}
      onChange={changeRadioSelectHandle}
      aria-label="animal type"
      className="grid grid-cols-2 gap-2"
    >
      {animalTypes.map((type) => (
        <Field as="div" key={type} className="flex items-center gap-1">
          <Radio
            value={type}
            className="group flex size-5 items-center justify-center rounded-full border border-gray-600 bg-white data-checked:bg-green-400 dark:data-checked:bg-green-600"
          >
            <CheckCircleIcon className="size-10 fill-white opacity-0 transition group-data-checked:opacity-100" />
          </Radio>
          <Label>{animalTypesMap[type]}</Label>
        </Field>
      ))}
    </RadioGroup>
  );
};

export default AnimalType;
